import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownFromBracket = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.25 7.75V11.5C12.25 11.9125 11.9125 12.25 11.5 12.25H2.5C2.0875 12.25 1.75 11.9125 1.75 11.5V7.75C1.75 7.3375 1.4125 7 1 7C0.5875 7 0.25 7.3375 0.25 7.75V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V7.75C13.75 7.3375 13.4125 7 13 7C12.5875 7 12.25 7.3375 12.25 7.75ZM7.75 7.5025L9.16 6.0925C9.4525 5.8 9.925 5.8 10.2175 6.0925C10.51 6.385 10.51 6.8575 10.2175 7.15L7.525 9.8425C7.2325 10.135 6.76 10.135 6.4675 9.8425L3.775 7.15C3.4825 6.8575 3.4825 6.385 3.775 6.0925C4.0675 5.8 4.54 5.8 4.8325 6.0925L6.25 7.5025V1C6.25 0.5875 6.5875 0.25 7 0.25C7.4125 0.25 7.75 0.5875 7.75 1V7.5025Z",
		fill: "#3C59F6"
	})
});
export default SvgArrowDownFromBracket;
